import { CHARACTER_VISIBILITY, CharacterHandlerReturnType } from "@next-platform/client-common-core";
import { Lorebook } from "@next-platform/packages-ts-types";
import { GroupMembersChatBot } from "@src/components/MembersGroupChat";
import { IDraftGroupCharacter } from "@src/types";

export enum GroupChatFormFields {
  COVER = "avatar_url",
  FIRST = "greeting_character_id",
  TYPE = "type",
  GREETING = "greeting",
  GUIDELINES = "guidelines",
  NAME = "name",
  MEMBERS = "members",
  PERSONA = "persona",
  SCENARIO = "scenario",
  TAGS = "tags",
  TITLE = "title",
  VISIBILITY = "visibility",
  SUB_CHARACTERS_ID = "sub_character_ids",
}

export type GroupChatFormProps = {
  id: string;
  name: string;
  avatarUrl: string;
  greeting: string;
  greetingCharacterId?: string | null;
  visibility: CHARACTER_VISIBILITY;
  title: string;
  scenario: string;
  onSave?: (
    draft: IDraftGroupCharacter,
    currentLorebooks: Lorebook[],
    initialLorebooks: Lorebook[],
    saveOptions?: { hasGroupContentChanged?: boolean },
  ) => CharacterHandlerReturnType<unknown>;
  setIsSubmitForManualReview: (isSubmitForManualReview: boolean) => void;
  isSubmitting: boolean;
  submitError: string;
  guidelines: boolean;
  tags: string[];
  isEdit: boolean;
  moderationStatus?: string;
  draftId: string;
  characterId?: string;
  isAlreadyDraft: boolean;
  errorCode: string | null;
  submitForManualReview: boolean;
  participants?: GroupMembersChatBot[];
  maxParticipants: number;
  lorebooks?: Lorebook[];
  /** The group's Lorebook was removed without its owner doing it (made private by its creator, or deleted). */
  isLorebookAutoDetached?: boolean;
};
